import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import image1 from "../../../images/service/New Home.png"
import image2 from "../../../images/service/RentHome.png"
import image3 from "../../../images/service/SellHome.png"

import { checkUserIsLogin } from "../../../APIs/APIHelperforWeb";
import { services } from "../../../data/services";
export default function Services() {
  
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    setIsLoggedIn(checkUserIsLogin());
  }, []);

  const handleServiceCardClick = (event, index) => {
    if (index !== 0 && isLoggedIn) {
      event.preventDefault();
      navigate("/dashboard");
      return;
    }

    if (index !== 0) {
      return;
    }

    event.preventDefault();
    enqueueSnackbar(
      isLoggedIn ? "You are already logged in. Filter here to search the property" : "Filter here to search the property",
      { variant: "info" }
    );
    navigate("/");
  };

  return (
    <section className="flat-section">
      <div className="container">
        <div
          className="box-title text-center wow fadeInUpSmall"
          data-wow-delay=".2s"
          data-wow-duration="2000ms"
        >
          <div className="text-subtitle text-primary">Explore Cities</div>
          <h3 className="title mt-4">Our Location For You</h3>
        </div>
        <div
          className="tf-grid-layout md-col-3 wow fadeInUpSmall"
          data-wow-delay=".4s"
          data-wow-duration="2000ms"
        >
          {services.map((elm, i) => (
            <a
              key={i}
              href={i !== 0 && !isLoggedIn ? "#modalLogin" : undefined}
              data-bs-toggle={i !== 0 && !isLoggedIn ? "modal" : undefined}
              onClick={(event) => handleServiceCardClick(event, i)}
            >
              <div className="box-service">
                <div className="image">
                  <img
                    className="lazyload"
                    alt="image-location"
                    src={i == 0 ? image1 : (i == 1 ? image2 : image3)}
                    width={204}
                    height={182}
                  />
                </div>
                <div className="content">
                  <h5 className="title">{elm.title}</h5>
                  <p className="description">{elm.description}</p>
                  <Link className="tf-btn btn-line">
                    Explore <span className="icon icon-arrow-right2" />
                  </Link>
                </div>

              </div>
            </a>
          ))}
        </div>
      </div>
    </section >
  );
}
